t = require('views/internal/teacup-with-helpers')('popover_confirmation_public_boards')

module.exports = ->
  t.div '.public-board-confirmation-popover', ->
    t.div '.public-board-confirmation-popover-title', ->
      t.span ->
        t.format 'public-board-confirmation-description'

    t.button '.js-submit.wide.primary.full.make-public-confirmation-button', ->
      t.format 'confirm'

    t.hr()

    t.div '.public-board-confirmation-popover-invitation-link', ->
      t.p ->
        t.format 'looking-for-invite-link'
        t.a '.js-action-link.looking-for-invite-link', { href: '#', target: '_blank' }, ->
          t.format 'invite-to-board-link'
        t.format 'option'


// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_confirmation_public_boards.coffee